export const RETRIEVE_ALL_PROGRAMMES = 'Retrieving All Programmes';
export const CREATING_PROGRAMME = 'Creating Programme';
export const RETRIEVE_PARENT_PROGRAMME = 'Retrieving Parent Programme';
export const RETRIEVE_SUB_PROGRAMME = 'Retrieving Sub Programme';
export const UPDATING_PARENT_PROGRAMME = 'Updating Parent Programme';
export const UPDATING_SUB_PROGRAMME = 'Updating Sub Programme';
export const PUBLISHING_PROGRAMME = 'Publishing Programme';
export const ARCHIVING_PROGRAMME = 'Archiving Programme';
